import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const shell = defineNamespace('shell', fr, en);
